import { createRouter, createWebHistory } from "vue-router";
import store from '../src/store/index.js';

// ── Layout / Auth ──
import IndexPage from "@/views/index.vue";
import WebStatus from "@/views/web_status.vue";
import userEdit from "../src/views/userEdit.vue";
import updatePasswordPage from "../src/views/update_password.vue";
import loginPage from "../src/views/login.vue";
import NotFound from "../src/views/error.vue";
import ComingSoonPage from "../src/views/ComingSoon.vue";

// ── Admin pages ──
import allStudentPage from "../src/views/all_student.vue";
import websiteTimePage from "../src/views/website_time.vue";
import websiteTextPage from "../src/views/website_text.vue";
import whatsappPage from "../src/views/whatsapp.vue";
import whatsappGroupsPage from "../src/views/whatsapp_groups.vue";

// ── Academic Years Config (NEW) ──
import AcademicYearsConfig from "@/views/academic_years/index.vue";
import AcademicYearEditPage from "@/views/academic_years/edit.vue";

// ── Financial Management (NEW) ──
import PaymentsPage from "@/views/payments/index.vue";
import FinancialSettingsPage from "@/views/financial_settings/index.vue";

// ── Subscriptions system (NEW) ──
import CoursesPage from "@/views/courses/index.vue";
import CourseCreatePage from "@/views/courses/create.vue";
import CourseEditPage from "@/views/courses/edit.vue";
import CourseLayout from "@/views/courses/CourseLayout.vue";
import CourseOverview from "@/views/courses/CourseOverview.vue";
import CoursePricing from "@/views/courses/CoursePricing.vue";
import PaymentMethodsPage from "@/views/payment_methods/index.vue";
import PaymentMethodCreatePage from "@/views/payment_methods/create.vue";
import PaymentMethodEditPage from "@/views/payment_methods/edit.vue";
import PaymentRequestsPage from "@/views/payment_requests/index.vue";
import SubscriptionsPage from "@/views/subscriptions/index.vue";
import SubscriptionReportsPage from "@/views/subscriptions/reports.vue";

// ── Settings ──
import SettingsIndex from "@/views/settings/index.vue";
import WhatsAppTemplatesSettings from "@/views/settings/whatsapp_templates.vue";

// ── About Us + Blog CMS (NEW) ──
import BlogIndex from "@/views/blog/index.vue";
import BlogAdd from "@/views/blog/add.vue";
import BlogEdit from "@/views/blog/edit.vue";
import BlogShow from "@/views/blog/show.vue";
import BlogCategories from "@/views/blog/categories.vue";
import AboutIndex from "@/views/about/index.vue";
import AboutEdit from "@/views/about/edit.vue";

// ── Messages ──
import MessagesIndex from "@/views/messages/index.vue";
import MessagesEdit  from "@/views/messages/edit.vue";

// ── Grade-based unified views (NEW) ──
import GradeStudents from "@/views/grades/students.vue";
import AddGradeStudent from "@/views/grades/add_student.vue";
import StudentsBarcodes from "@/views/grades/students_barcodes.vue";
import StudentsBarcodesPrint from "@/views/grades/students_barcodes_print.vue";
import GroupsIndex from "@/views/grades/groups/index.vue";
import GroupShow from "@/views/grades/groups/show.vue";
import GroupWhatsApp from "@/views/grades/groups/whatsapp.vue";
import GroupMessages from "@/views/grades/groups/messages.vue";

// ── Shared module views (updated to accept gradeSlug param) ──
import attendancePage from "../src/views/attendance.vue";
import absencePage from "../src/views/absence.vue";

// ── Lessons / Content / Questions / Exams ──
import IndexLesson from "@/views/lessons/index.vue";
import AddLesson from "@/views/lessons/add.vue";
import EditLesson from "@/views/lessons/edit.vue";

import IndexContent from "@/views/contents/index.vue";
import AddContent from "@/views/contents/add.vue";
import EditContent from "@/views/contents/edit.vue";

import QuestionPage from "../src/views/questions/index.vue";
import QuestionAddPage from "../src/views/questions/add.vue";
import QuestionEditPage from "../src/views/questions/edit.vue";

import ExamPage from "../src/views/exams/index.vue";
import ExamAddPage from "../src/views/exams/add.vue";
import ExamEditPage from "../src/views/exams/edit.vue";

// ── Legacy per-grade views (kept for backward compat) ──
import reservationPage from "../src/views/reservation.vue";
import reservationAddPage from "../src/views/add_reservation.vue";
import threeSecondaryPage from "../src/views/three_secondary.vue";
import threeSecondaryAddPage from "../src/views/add_three_secondary.vue";
import twoSecondaryPage from "../src/views/two_secondary.vue";
import twoSecondaryAddPage from "../src/views/add_two_secondary.vue";
import oneSecondaryPage from "../src/views/one_secondary.vue";
import oneSecondaryAddPage from "../src/views/add_one_secondary.vue";

const auth = { requiresAuth: true };
const guest = { guest: true };

const routes = [
    // ── Core ──
    { path: "/", component: IndexPage, name: "IndexPage", meta: auth },
    { path: "/login", component: loginPage, name: "login", meta: guest },
    { path: "/web_status", component: WebStatus, name: "WebStatus", meta: auth },
    { path: "/user/edit/:id", component: userEdit, name: "userEdit", meta: auth },
    { path: "/update_password/:id", component: updatePasswordPage, name: "update_password", meta: auth },

    // ── Temporary placeholder: features under maintenance are redirected here
    // instead of their real route. To restore a feature, change its button's
    // target back to the original route — nothing here needs to change. ──
    { path: "/coming-soon", component: ComingSoonPage, name: "ComingSoon", meta: auth },

    // ── Academic Years Config (NEW) ──
    { path: "/academic-years", component: AcademicYearsConfig, name: "AcademicYearsConfig", meta: auth },
    { path: "/academic-years/:id/edit", component: AcademicYearEditPage, name: "AcademicYearEdit", meta: auth },

    // ── Grade-based unified routes (NEW) ──
    { path: "/grades/:gradeSlug/students", component: GradeStudents, name: "GradeStudents", meta: auth },
    { path: "/grades/:gradeSlug/students/add", component: AddGradeStudent, name: "AddGradeStudent", meta: auth },
    { path: "/grades/:gradeSlug/students/barcodes", component: StudentsBarcodes, name: "StudentsBarcodes", meta: auth },
    { path: "/grades/:gradeSlug/students/barcodes-print", component: StudentsBarcodesPrint, name: "StudentsBarcodesPrint", meta: auth },
    { path: "/grades/:gradeSlug/attendance", component: attendancePage, name: "gradeAttendance", meta: auth },
    { path: "/grades/:gradeSlug/absence", component: absencePage, name: "gradeAbsence", meta: auth },
    { path: "/grades/:gradeSlug/payments", component: PaymentsPage, name: "gradePayments", meta: auth },
    { path: "/grades/:gradeSlug/groups", component: GroupsIndex, name: "gradeGroups", meta: auth },
    { path: "/grades/:gradeSlug/groups/:groupId", component: GroupShow, name: "gradeGroupShow", meta: auth },
    { path: "/grades/:gradeSlug/groups/:groupId/whatsapp", component: GroupWhatsApp, name: "gradeGroupWhatsApp", meta: auth },
    { path: "/grades/:gradeSlug/groups/:groupId/messages", component: GroupMessages, name: "gradeGroupMessages", meta: auth },

    // ── Financial Settings ──
    { path: "/financial-settings", component: FinancialSettingsPage, name: "FinancialSettings", meta: auth },

    // ── Subscriptions system (NEW) ──
    { path: "/courses", component: CoursesPage, name: "Courses", meta: auth },
    { path: "/courses/create", component: CourseCreatePage, name: "CourseCreate", meta: auth },
    { path: "/courses/:id/edit", component: CourseEditPage, name: "CourseEdit", meta: auth },

    // ── Course workspace (NEW): course header + tabbed sub-navigation, every
    // tab reuses the existing lesson/content/question/exam CRUD pages scoped
    // to :courseId instead of the legacy :gradeSlug. meta:auth on the parent
    // covers every child route via router.beforeEach's to.matched.some(...).
    {
      path: "/courses/:courseId",
      component: CourseLayout,
      meta: auth,
      children: [
        { path: "", component: CourseOverview, name: "CourseOverview" },
        { path: "pricing", component: CoursePricing, name: "CoursePricing" },

        { path: "branches", component: IndexLesson, name: "CourseBranches", meta: { type: "branch" } },
        { path: "branches/add", component: AddLesson, name: "CourseBranchAdd", meta: { type: "branch" } },
        { path: "branches/edit/:id", component: EditLesson, name: "CourseBranchEdit", meta: { type: "branch" } },

        { path: "units", component: IndexLesson, name: "CourseUnits", meta: { type: "unit" } },
        { path: "units/add", component: AddLesson, name: "CourseUnitAdd", meta: { type: "unit" } },
        { path: "units/edit/:id", component: EditLesson, name: "CourseUnitEdit", meta: { type: "unit" } },

        { path: "lessons", component: IndexLesson, name: "CourseLessons", meta: { type: "lesson" } },
        { path: "lessons/add", component: AddLesson, name: "CourseLessonAdd", meta: { type: "lesson" } },
        { path: "lessons/edit/:id", component: EditLesson, name: "CourseLessonEdit", meta: { type: "lesson" } },

        { path: "contents", component: IndexContent, name: "CourseContents" },
        { path: "contents/add", component: AddContent, name: "CourseContentAdd" },
        { path: "contents/edit/:id", component: EditContent, name: "CourseContentEdit" },

        { path: "question-bank", component: QuestionPage, name: "CourseQuestions" },
        { path: "question-bank/add", component: QuestionAddPage, name: "CourseQuestionAdd" },
        { path: "question-bank/edit/:id", component: QuestionEditPage, name: "CourseQuestionEdit" },

        { path: "exams", component: ExamPage, name: "CourseExams" },
        { path: "exams/add", component: ExamAddPage, name: "CourseExamAdd" },
        { path: "exams/edit/:id", component: ExamEditPage, name: "CourseExamEdit" },
      ],
    },
    { path: "/payment-methods", component: PaymentMethodsPage, name: "PaymentMethods", meta: auth },
    { path: "/payment-methods/create", component: PaymentMethodCreatePage, name: "PaymentMethodCreate", meta: auth },
    { path: "/payment-methods/:id/edit", component: PaymentMethodEditPage, name: "PaymentMethodEdit", meta: auth },
    { path: "/payment-requests", component: PaymentRequestsPage, name: "PaymentRequests", meta: auth },
    { path: "/subscriptions", component: SubscriptionsPage, name: "Subscriptions", meta: auth },
    { path: "/subscription-reports", component: SubscriptionReportsPage, name: "SubscriptionReports", meta: auth },

    // ── Settings ──
    { path: "/settings", component: SettingsIndex, name: "Settings", meta: auth },
    { path: "/settings/whatsapp-templates", component: WhatsAppTemplatesSettings, name: "WhatsAppTemplatesSettings", meta: auth },

    // ── About Us + Blog CMS: TEMP (dev phase) — no permission gating yet, all
    // routes just require auth. A real permission system (about.*, blog.*) will
    // be layered back in once all modules are finished. ──
    { path: "/blog", component: BlogIndex, name: "BlogIndex", meta: auth },
    { path: "/blog/categories", component: BlogCategories, name: "BlogCategories", meta: auth },
    { path: "/blog/add", component: BlogAdd, name: "BlogAdd", meta: auth },
    { path: "/blog/edit/:id", component: BlogEdit, name: "BlogEdit", meta: auth },
    { path: "/blog/:id", component: BlogShow, name: "BlogShow", meta: auth },
    { path: "/about", component: AboutIndex, name: "AboutIndex", meta: auth },
    { path: "/about/edit", component: AboutEdit, name: "AboutEdit", meta: auth },

    // ── Messages ──
    { path: "/messages",                         component: MessagesIndex, name: "MessagesIndex",                  meta: auth },
    { path: "/messages/payment-confirmation",    component: MessagesEdit,  name: "EditPaymentConfirmation",        props: { templateCode: "payment_confirmation" },      meta: auth },
    { path: "/messages/payment-reminder",        component: MessagesEdit,  name: "EditPaymentReminder",            props: { templateCode: "payment_reminder_bulk" },     meta: auth },
    { path: "/messages/absence",                 component: MessagesEdit,  name: "EditAbsence",                    props: { templateCode: "absence_notification" },      meta: auth },
    { path: "/messages/absence-bulk",            component: MessagesEdit,  name: "EditAbsenceBulk",                props: { templateCode: "absence_notification_bulk" }, meta: auth },
    { path: "/messages/reservation",             component: MessagesEdit,  name: "EditReservation",                props: { templateCode: "reservation_notification" },  meta: auth },
    { path: "/messages/attendance-confirmation", component: MessagesEdit,  name: "EditAttendanceConfirmation",     props: { templateCode: "attendance_confirmation" },   meta: auth },

    // ── Admin ──
    { path: "/all_student", component: allStudentPage, name: "allStudentPage", meta: auth },
    { path: "/website_time", component: websiteTimePage, name: "websiteTime", meta: auth },
    { path: "/website_text", component: websiteTextPage, name: "websiteText", meta: auth },
    { path: "/whatsapp_links", component: whatsappPage, name: "whatsapp_link", meta: auth },
    { path: "/whatsapp_groups", component: whatsappGroupsPage, name: "whatsapp_groups", meta: auth },

    // ── Lessons / Content / Questions / Exams (accept any slug including new ones) ──
    { path: "/:type/:gradeSlug", component: IndexLesson, name: "IndexLesson", meta: auth },
    { path: "/:type/:gradeSlug/add", component: AddLesson, name: "AddLesson", meta: auth },
    { path: "/:type/:gradeSlug/edit/:id", component: EditLesson, name: "EditLesson", meta: auth },
    { path: "/:gradeSlug/content", component: IndexContent, name: "IndexContent", meta: auth },
    { path: "/:gradeSlug/content/add", component: AddContent, name: "AddContent", meta: auth },
    { path: "/:gradeSlug/content/edit/:id", component: EditContent, name: "EditContent", meta: auth },
    { path: "/:gradeSlug/questions", component: QuestionPage, name: "questions", meta: auth },
    { path: "/:gradeSlug/question/add", component: QuestionAddPage, name: "questionAdd", meta: auth },
    { path: "/:gradeSlug/question/edit/:id", component: QuestionEditPage, name: "QuestionEditPage", meta: auth },
    { path: "/:gradeSlug/exams", component: ExamPage, name: "Exams", meta: auth },
    { path: "/:gradeSlug/exam/add", component: ExamAddPage, name: "ExamAdd", meta: auth },
    { path: "/:gradeSlug/exam/edit/:id", component: ExamEditPage, name: "ExamEditPage", meta: auth },

    // ── Legacy attendance/absence routes (kept for backward compat) ──
    { path: "/attendance/:gradeSlug", component: attendancePage, name: "attendance", meta: auth },
    { path: "/absence/:gradeSlug", component: absencePage, name: "absence", meta: auth },

    // ── Legacy per-grade routes (kept for backward compat — redirect to new unified views) ──
    { path: "/reservation", component: reservationPage, name: "reservation", meta: auth },
    { path: "/reservation/add", component: reservationAddPage, name: "reservationAdd", meta: auth },
    { path: "/three_secondary", component: threeSecondaryPage, name: "threeSecondaryPage", meta: auth },
    { path: "/three_secondary/add", component: threeSecondaryAddPage, name: "threeSecondaryAddPage", meta: auth },
    { path: "/two_secondary", component: twoSecondaryPage, name: "twoSecondaryPage", meta: auth },
    { path: "/two_secondary/add", component: twoSecondaryAddPage, name: "twoSecondaryAddPage", meta: auth },
    { path: "/one_secondary", component: oneSecondaryPage, name: "oneSecondaryPage", meta: auth },
    { path: "/one_secondary/add", component: oneSecondaryAddPage, name: "oneSecondaryAddPage", meta: auth },

    // ── 404 ──
    { path: "/404", component: NotFound },
    { path: "/:catchAll(.*)", redirect: "/404" },
];

const router = createRouter({
    routes,
    history: createWebHistory(),
    hashbang: false,
    mode: 'html5',
    linkActiveClass: "active",
    scrollBehavior() {
        return window.scrollTo({ top: 0, behavior: 'smooth' });
    },
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) { next(); return; }
        next("/login");
    } else {
        next();
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.guest)) {
        if (store.getters.isAuthenticated) { next("/"); return; }
        next();
    } else {
        next();
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requiresAdmin)) {
        if (store.getters.isAdmin) { next(); return; }
        next("/");
    } else {
        next();
    }
});

export default router;
